import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKeepassxcComponent } from './simple-icons-keepassxc.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKeepassxcComponent ],
    exports:      [ SimpleIconsKeepassxcComponent ],
    bootstrap:    []
})
export class SimpleIconsKeepassxcModule {}
